import React, { useEffect, useState } from 'react';
import { Card, Form, Input, Button, message, Row, Col, Spin } from 'antd';
import { getUserInfo } from '../../utils/helpers';
import { bophanService } from '../../services';

const Bophankinhdoanh = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await bophanService.getBophankinhdoanh();
      if (res.success) {
        form.setFieldsValue(res.data);
        message.success(res.message);
      } else {
        message.error(res.message || 'Lỗi khi lấy dữ liệu');
      }
    } catch (err) {
      console.error('Fetch bophan error', err);
      message.error('Lỗi kết nối server');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const token = localStorage.getItem('accessToken');
      const payload = {
        accessToken: token,
        ...values
      };
      const res = await bophanService.updateBophankinhdoanh(payload);
      if (res.success) {
        message.success(res.message);
        form.setFieldsValue(res.data);
      } else {
        message.error(res.message || 'Lỗi khi cập nhật');
      }
    } catch (err) {
      console.error('Update bophan error', err);
      message.error('Lỗi kết nối server');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <Card title="Quản lý Phòng Kinh Doanh">
        <Spin spinning={loading}>
          <Form layout="vertical" form={form} onFinish={handleSubmit}>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item name="Name" label="Tên bộ phận">
                  <Input />
                </Form.Item>
              </Col>

              {[1,2,3,4,5,6].map(i => (
                <Col span={12} key={`col-${i}`}>
                  <Form.Item name={`NamePhong${i}`} label={`Tên phòng ${i}`}>
                    <Input />
                  </Form.Item>
                </Col>
              ))}

              <Col span={24} style={{ textAlign: 'right' }}>
                <Button type="primary" htmlType="submit">Cập nhật</Button>
              </Col>
            </Row>
          </Form>
        </Spin>
      </Card>
    </div>
  );
};

export default Bophankinhdoanh;
